import { Box, styled } from "@mui/material";

interface CustomProps {
  noBorder?: boolean;
}

const Toolbar = styled(Box, {
  shouldForwardProp: (prop) => prop !== "noBorder",
})<CustomProps>(({ theme, noBorder }) => {
  return {
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1),
    borderBottom: noBorder ? "none" : "1px solid",
    borderBottomColor: theme.palette.common.toolbarBorder,
  };
});

export default Toolbar;
